module.exports = __webpack_public_path__ + "img/serve1.ca5928ff.png";